import { RSAA } from '@flowio/redux-async-middleware';
import { operationTypes } from '@flowio/redux-resource';
import ApiPropTypes from '@flowio/api-prop-types';
import PropTypes from 'prop-types';

import { api } from '../../../../utilities/clients';
import { createResourceTypeDescriptors } from '../../helpers';
import { withAssertPropTypes } from '../../../../utilities/prop-types';

export default withAssertPropTypes({
  organizationId: PropTypes.string.isRequired,
  priceBookKey: PropTypes.string.isRequired,
  priceBookForm: ApiPropTypes.priceBookForm.isRequired,
})(({ organizationId, priceBookKey, priceBookForm }) => ({
  [RSAA]: {
    types: createResourceTypeDescriptors({
      operationType: operationTypes.UPDATE,
      resourceType: 'priceBooks',
    }),
    callAPI: (state) => api.priceBooks(state).putByKey(organizationId, priceBookKey, {
      body: priceBookForm,
    }),
  },
}));
